import { PlaceApiPlaceCreateRequest } from "../../openapi/api";
import appApiClient from "./coreApiClient";
import useBaseMutation from "./useBaseMutation";

export const usePlaceCreateMutation = () =>
  useBaseMutation({
    mutationFn: (req: PlaceApiPlaceCreateRequest, config) =>
      appApiClient.placeApi.placeCreate(req, config),
  });
